import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addsocialChannel from "./components/addsocialChannel";
export default {
  name: "socialChannel",
  mixins: [loadMoreList, serchSelect],
  components: {
    addsocialChannel: addsocialChannel
  },
  data: function data() {
    return {
      pagingReqFn: "socialData",
      pagingReqValue: "",
      tableBody: 'socialChannelTable',
      sortReq: 'socialChangeSort'
    };
  },
  created: function created() {
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'socialDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};